type ApiConfig = {
	JbhApimKey: string;
	ReceiveUrl: string;
	ReceivingUrl: string;
	VendorUrl: string;
};

// Configuration values sourced from environment variables (set during build via pipeline)
const JBH_APIM_KEY = import.meta.env.VITE_JBH_APIM_KEY || "";
const RECEIVING_API_URL = import.meta.env.VITE_RECEIVING_API_URL || "";
const APIM_BASE_URL = import.meta.env.VITE_APIM_BASE_URL || "";

const API_CONFIG: ApiConfig = {
	JbhApimKey: JBH_APIM_KEY,
	ReceiveUrl: encodeURI(`${APIM_BASE_URL}/ReceiveApi`),
	ReceivingUrl: encodeURI(RECEIVING_API_URL),
	VendorUrl: encodeURI(`${APIM_BASE_URL}/VendorApi`),
};

export default API_CONFIG;
